import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductUnitOfMeasureService = {
  async getByBarcodeAndBranchCode(barcode, branchCode, select) {
    const requestScreenData = {
      url: "api/ProductUnitOfMeasure",
      top: "1",
      filter: `Barcode eq '${barcode}' and BranchCode eq '${branchCode}' and Inactive eq 'N'`,
      expand: "Product(select=Description1,UnitOfMeasureCode)",
    };

    if (select) requestScreenData.select = select;

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/ProductUnitOfMeasure";
    return ApiService.createDataSource(url, params);
  },

  dataSourceConfigList(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/ProductUnitOfMeasure",
      expand:
        "Product($select=Code,Description1,UnitOfMeasureCode,IsKit), Branch($select=Description)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async save(mode, productUnitOfMeasure) {
    var payload = productUnitOfMeasure;
    var url = "api/ProductUnitOfMeasure";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(
        url,
        productUnitOfMeasure.RecordId,
        payload,
        "Guid"
      );
    }
  },

  async delete(productUnitOfMeasure) {
    var url = "api/ProductUnitOfMeasure";

    return await ApiService.delete(url, productUnitOfMeasure.RecordId, "Guid");
  },
  async getByBarcode(barcode) {
    const requestScreenData = {
      url: "api/ProductUnitOfMeasure",
      top: "1",
      filter: `Barcode eq '${barcode}'`,
      expand: "Product",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ProductUnitOfMeasureService };
